import React from 'react';

import { Table, TableBody, TableHead, TableHeader, TableRow } from '@dashboard/components/ui/table';
import TeamMemberRow from './TeamMemberRow';

export default function TeamMembersTable({ members, sellerId }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-border">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className="pl-4">Member</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Other stores</TableHead>
            <TableHead>Emails</TableHead>
            <TableHead>Last active</TableHead>
            <TableHead className="pr-4">
              <span className="sr-only">Actions</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className="[&_tr:last-child]:border-0">
          {members.map(teamMember => (
            <TeamMemberRow
              key={teamMember.user?._id ?? teamMember._id}
              teamMember={teamMember}
              sellerId={sellerId}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
